import { render, staticRenderFns } from "./ExtractorSchema.vue?vue&type=template&id=091e3f42&scoped=true"
import script from "./ExtractorSchema.vue?vue&type=script&lang=ts"
export * from "./ExtractorSchema.vue?vue&type=script&lang=ts"
import style0 from "./ExtractorSchema.vue?vue&type=style&index=0&id=091e3f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091e3f42",
  null
  
)

export default component.exports